import { TRootState } from 'Redux/Reducers';

export const getInvoiceCount = (state: TRootState) => state.invoice.maxCount;
